export const textAreaStyle = {
  padding: "10px",
  fontSize: "16px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  resize: "none",
} as React.CSSProperties;
